export const WELCOME_REGULAR = 'WELCOME_REGULAR';
export const WELCOME_SHOWROOM = 'WELCOME_SHOWROOM';
export const PUBLISHED_REGULAR = 'PUBLISHED_REGULAR';
export const PUBLISHED_PREMIUM = 'PUBLISHED_PREMIUM';
export const PUBLISHED_SHOWROOM = 'PUBLISHED_SHOWROOM';
